module.exports = __webpack_public_path__ + "dist/media/logo--lv.a5a50771.svg";